export default class PlaceMagazineApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.DashAPI.ApiPathMgr.add(PlaceMagazineApi.GetArticlesPath);
    }

    getArticles() {
        return this.DashAPI.CORE.get(PlaceMagazineApi.GetArticlesPath);
    }
}

PlaceMagazineApi.GetArticlesPath = '/api/place-magazine/articles';



// WEBPACK FOOTER //
// ./src/PublicApi/place-magazine/PlaceMagazineApi.js


// WEBPACK FOOTER //
// webpack:///src/PublicApi/place-magazine/PlaceMagazineApi.js